module.exports = __webpack_public_path__ + "img/LOGO_TCS_AZUL.b349254a.png";